var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockedGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_708_546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C3.93225 0 2.25 1.68225 2.25 3.75V5.25C2.25 5.66421 1.91421 6 1.5 6V6C1.10218 6 0.720644 6.15804 0.43934 6.43934C0.158035 6.72064 0 7.10218 0 7.5V13.5C0 13.8978 0.158035 14.2794 0.43934 14.5607C0.720644 14.842 1.10218 15 1.5 15H10.5C10.8978 15 11.2794 14.842 11.5607 14.5607C11.842 14.2794 12 13.8978 12 13.5V7.5C12 7.10218 11.842 6.72064 11.5607 6.43934C11.2794 6.15804 10.8978 6 10.5 6V6C10.0858 6 9.75 5.66421 9.75 5.25V3.75C9.75 1.68225 8.06775 0 6 0ZM3.75 3.75C3.75 2.5095 4.7595 1.5 6 1.5C7.2405 1.5 8.25 2.5095 8.25 3.75V5C8.25 5.55228 7.80228 6 7.25 6H4.75C4.19771 6 3.75 5.55228 3.75 5V3.75ZM7.18477 11.4149C6.96453 11.6976 6.75 12.0132 6.75 12.3715V12.75C6.75 13.1642 6.41421 13.5 6 13.5V13.5C5.58579 13.5 5.25 13.1642 5.25 12.75V12.372C5.25 12.0134 5.03526 11.6976 4.81462 11.415C4.74926 11.3313 4.69268 11.2404 4.64612 11.1438C4.515 10.8715 4.46946 10.566 4.51551 10.2673C4.56156 9.9687 4.69704 9.69103 4.90407 9.47095C5.11111 9.25086 5.37999 9.09869 5.67525 9.0345C5.89456 8.98601 6.12196 8.98736 6.34068 9.03846C6.5594 9.08956 6.76386 9.18911 6.93899 9.32975C7.11411 9.4704 7.25543 9.64856 7.35253 9.8511C7.44962 10.0536 7.50002 10.2754 7.5 10.5C7.49957 10.7623 7.43001 11.0199 7.29835 11.2467C7.26423 11.3055 7.22626 11.3617 7.18477 11.4149Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_708_546",
    x: -4,
    y: -4,
    width: 20,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_708_546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_708_546",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedGame);
export default __webpack_public_path__ + "static/media/lockedGame.145853bd93925d02fedde95388fc4cff.svg";
export { ForwardRef as ReactComponent };